import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'organization';

export const GetOrganizationDetails = (reqData: any) => {
  return axios.get(API_URL, { params: reqData });
};
export const GetOrganizationDetailsByName = (reqData: any) => {
  return axios.get(API_URL + '/getOrganizationByName', { params: reqData });
};

export const GetOrganizationSetting = async (reqData: any) => {
  return await axios.get(API_URL + '/setting', { params: reqData });
};

export const UpdateOrganizationSettings = (reqData: object) => {
  return axios.put(API_URL + '/setting', reqData);
};

export const GetBasicSettings = (reqData: object) => {
  return axios.get(API_URL + '/getbasicsetting', { params: reqData });
};

export const CreatePaymentSetting = (reqData: object) => {
  return axios.post(API_URL + '/paymentSettings', reqData);
};

export const UpdatePaymentSetting = (reqData: object) => {
  return axios.put(API_URL + '/paymentSettings', reqData);
};
export const UpdatePaymentStatus = (reqData: object) => {
  return axios.put(API_URL + '/paymentSettingStatus', reqData);
};

export const CreateEmailSetting = (reqData: object) => {
  return axios.post(API_URL + '/emailSettings', reqData);
};

export const UpdateEmailSetting = (reqData: object) => {
  return axios.put(API_URL + '/emailSettings', reqData);
};
export const UpdateEmailStatus = (reqData: object) => {
  return axios.put(API_URL + '/emailSettingStatus', reqData);
};
export const CreateSmsSetting = (reqData: object) => {
  return axios.post(API_URL + '/smsSettings', reqData);
};

export const UpdateSmsSetting = (reqData: object) => {
  return axios.put(API_URL + '/smsSettings', reqData);
};

export const UpdateSmsStatus = (reqData: object) => {
  return axios.put(API_URL + '/smsSettingStatus', reqData);
};

export const UpdateApiSetting = (reqData: object) => {
  return axios.put(API_URL + '/apiSettings', reqData);
};

export const getOrganizationUpdatedAzureStorageSize = (organizationId: string) => {
  return axios.get(API_URL + `/getUpdatedAzureStorageDetails/${organizationId}`);
};

export const updateClassroomConfig = (reqData: any) => {
  return axios.put(API_URL + `/updateClassroomConfig`, reqData);
};

export const updateOMRConfig = (reqData: any) => {
  return axios.put(API_URL + `/updateOMRConfig`, reqData);
};

export const getOMRConfig = () => {
  return axios.get(API_URL + `/getOMRConfig`);
};

// New OMR Config CRUD APIs
export const getAllOMRConfigs = (reqData: { orgId: string; skip: number; limit: number; search?: string }) => {
  return axios.get(API_URL + `/omrConfigs`, { params: reqData });
};

export const getOMRConfigById = (configId: string) => {
  return axios.get(API_URL + `/omrConfig/${configId}`);
};

export const createOMRConfig = (reqData: any) => {
  return axios.post(API_URL + `/omrConfig`, reqData);
};

export const updateOMRConfigById = (configId: string, reqData: any) => {
  return axios.put(API_URL + `/omrConfig/${configId}`, reqData);
};

export const deleteOMRConfigById = (configId: string) => {
  return axios.delete(API_URL + `/omrConfig/${configId}`);
};

export const getSubOrganization = (reqData: object) => {
  return axios.get(API_URL + `/subOrg`, { params: reqData });
};

export const getSubTrainingCenter = (reqData: object) => {
  return axios.get(API_URL + '/commonSubOrg', { params: reqData })
}

export const vidhyalayaSync = (reqData: { orgCode: string }) => {
  return axios.get(API_URL + '/vidhyalayaSync', {
    params: reqData
  });
};

export const Savevidhyalaya = (reqData: object) => {
  return axios.post(API_URL + '/saveVidhyalayaData', reqData);
};

export const getNCVETDashboardData = (params?: { year?: number }) => {
  return axios.get(API_URL + '/ncvet-dashboard-data', { params });
};

export const getNCVETDashboardAwardingBody = (params: { page: number; skip: number }) => {
  return axios.get(API_URL + '/ncvet-dashboard-awarding-body', { params });
};

export const getNCVETDashboardTrainingCenter = (params: { page: number; skip: number }) => {
  return axios.get(API_URL + '/ncvet-dashboard-training-center', { params });
};

export const checkStorageValidation = (reqData: {
  storageType: string;
  azureStorageConfig?: {
    connectionString: string;
    containerName: string;
  };
  awsStorageConfig?: {
    accessKeyId: string;
    secretAccessKey: string;
    bucketName: string;
    region: string;
  };
}) => {
  return axios.post(API_URL + '/checkStorageValidation', reqData);
};
